import type { ReactNode } from 'react';
import { MobileNav, Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface Props {
  title?: string;
  subtitle?: string;
  children: ReactNode;
}

export function Shell({ title, subtitle, children }: Props) {
  return (
    <div className="flex h-dvh overflow-hidden bg-bg">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar title={title} subtitle={subtitle} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6">
          {children}
        </main>
        <MobileNav />
      </div>
    </div>
  );
}
